import axiosInstance from "../../../core/api/axios";

export async function getCredits() {
  try {
    const response = await axiosInstance.get(`/essays/credits`)

    return response.data
  } catch(e: any) {
    throw new Error(e);
  }
}
